export const exterior_view04ImageOptions = {
  angle: 'exterior_view04',
  staticOptions: {
    HullColour: 1,
    Bowsprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SprayHoodType: 1,
    SprayHood: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: null
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'SprayHoodType',
      dependency: null
    },
    {
      option: 'SprayHood',
      dependency: 'SprayHoodType'
    },
    {
      option: 'Wheel',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC38/views/exterior_view04.js